import { render } from "./TemplateModalEvent.vue?vue&type=template&id=310ffcac&ts=true"
import script from "./TemplateModalEvent.vue?vue&type=script&lang=ts"
export * from "./TemplateModalEvent.vue?vue&type=script&lang=ts"

import "./TemplateModalEvent.vue?vue&type=style&index=0&id=310ffcac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__